import { createSingleEntityStore } from '@recruitee/ngrx';

import { ReferralsAssignedOffersList } from './types';

const { actions, reducer, namespace } = createSingleEntityStore<ReferralsAssignedOffersList>()(
  `ReferralsAssignedOffers`,
  {
    customActions: adapter => ({
      fetch: (
        state,
        payload: { id: number; searchParams: { q: string | null; page: number; limit: number } },
      ) => adapter.markAsPending(state),
    }),
  },
);

const ReferralsAssignedOffersActions = <Pick<typeof actions, 'fetch' | 'fetchSuccess'>>actions;

export {
  ReferralsAssignedOffersActions,
  reducer as ReferralsAssignedOffersReducer,
  namespace as ReferralsAssignedOffersNamespace,
};
